import useTableRequest from "../../hooks/useTableRequest";
import { useEffect, useState } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { provinceListColumns } from "../../constant/tables-columns/tablesColums";
import { useNavigate } from "react-router";

export default function ProvinceList() {
  const tableRequest = useTableRequest({ initialLoading: true });
  const [provinces, setProvinces] = useState([]);

  const getProvinces = async (params) => {
    const path = "admin/provinces";
    return tableRequest.load({ path, params: { ...params } }, (response) => {
      setProvinces(response?.data?.result);
      console.log(response);
    });
  };

  useEffect(() => {
    getProvinces({});
  }, []);

  const data = provinces?.map((item) => {
    return {
      ...item,
      key: item._id,
      cityNumber: item?.cities?.length || "-",
      id: item._id,
    };
  });

  console.log(data);

  const navigate = useNavigate();

  const editUser = (data) => {
    navigate("/edit-cities", { state: data });
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={"لیست استان ها"} />
      <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry} columns={provinceListColumns} rows={data} onEdit={editUser} />
    </div>
  );
}
